import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { OAuth_Service } from '../services/system/OAuth_Service';


@Injectable()
export class Logout_Guard implements CanActivate {

    constructor(private OAuth_Service: OAuth_Service) {
        this.OAuth_Service.initialise_OAuth();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        //wait for the discovery document so logOut knows the identity server logout url
        return this.OAuth_Service.isAuthorized.then(() => {
            this.OAuth_Service.logoff();
            return false;
        });
    }
}
